import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const createOrUpdateFromRetsOpenHouse = async ({
  shouldCreateCopy,
  retsOpenHouseId,
  updates,
}: {
  shouldCreateCopy: boolean;
  retsOpenHouseId: string;
  updates: Record<string, any>;
}) => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `/rets/openhouse/${retsOpenHouseId}`,
    data: { shouldCreateCopy, updates },
  };

  const { data: newId } = await axios.request<string>(config);

  return newId;
};

export default createOrUpdateFromRetsOpenHouse;
